module.exports = __webpack_public_path__ + "static/media/Volex_bild_undersida11.f6d1819c.jpg";